import $ from 'jquery';
export var checkboxElements = function checkboxElements() {
  $(document).on('change', 'input[type="checkbox"]', function (e) {
    var checkbox = $(e.target).closest('[role="checkbox"]')[0];

    if ($(checkbox).attr('aria-checked')) {
      $(checkbox).attr('aria-checked', $(checkbox).attr('aria-checked') === 'false' ? 'true' : 'false');
    }
  });
};
export default (function () {
  checkboxElements();
});